import React, { useContext } from "react";
import { useNotifications } from "../../context/NotificationContext";

const AllNotifications = () => {
  const { notifications, unreadCount, markAsRead, markAllAsRead } =
    useNotifications();

  return (
    <div className="all-notifications-page">
      <div className="container">
        {/* Header */}
        <div className="notification-page-header">
          <div>
            <h2>Notifications</h2>
            <p>
              You have {unreadCount} unread notification
              {unreadCount !== 1 ? "s" : ""}
            </p>
          </div>

          {unreadCount > 0 && (
            <button
              type="button"
              className="mark-all-btn"
              onClick={markAllAsRead}
            >
              Mark all as read
            </button>
          )}
        </div>

        {/* Notification List */}
        <div className="notification-card">
          {notifications.length === 0 ? (
            <div className="notification-empty">
              <img src="assets/images/empty.jpg" alt="No notifications" />

              <h3>No Notifications Yet</h3>

              <p>You don't have any notifications at the moment.</p>
            </div>
          ) : (
            <div className="notification-list">
              {notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`notification-item ${
                    Number(notification.is_read) === 0 ? "unread" : ""
                  }`}
                  onClick={() => {
                    if (Number(notification.is_read) === 0) {
                      markAsRead(notification.id);
                    }
                  }}
                >
                  {/* Icon */}
                  <span className="avatar_img">
                    <img alt="" src="assets/images/m_user.png" />
                  </span>

                  {/* Content */}
                  <div className="notification-content">
                    <div className="notification-title-row">
                      <h4>{notification.title || "Notification"}</h4>

                      {Number(notification.is_read) === 0 && (
                        <span className="unread-dot"></span>
                      )}
                    </div>

                    <p>{notification.message}</p>

                    <span className="notification-time">
                      {notification.created_at &&
                        new Date(notification.created_at).toLocaleString()}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllNotifications;
